// src/components/trends/DailyCapModal.js
import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const DailyCapModal = ({ isOpen, onClose, isDarkMode = true }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div 
        className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          transition={{ type: "spring", stiffness: 350, damping: 25 }}
          onClick={(e) => e.stopPropagation()}
          className={`max-w-sm w-full p-6 rounded-3xl border shadow-2xl text-center space-y-5 ${
            isDarkMode 
              ? "bg-zinc-900 border-zinc-800 text-zinc-200" 
              : "bg-white border-slate-200 text-slate-800"
          }`}
        >
          {/* Icon Header */}
          <div className="w-14 h-14 rounded-full bg-red-500/10 border-2 border-red-500/40 flex items-center justify-center mx-auto shadow-lg shadow-red-500/10">
            <svg 
              className="w-7 h-7 text-red-500" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Top vertical bar */}
              <line 
                x1="12" 
                y1="6" 
                x2="12" 
                y2="14" 
                stroke="currentColor" 
                strokeWidth="3.5" 
                strokeLinecap="round" 
              />
              {/* Bottom dot */}
              <circle 
                cx="12" 
                cy="18" 
                r="1.75" 
                fill="currentColor" 
              />
            </svg>
          </div>

          {/* Title & Subtitle */}
          <div>
            <h3 className={`text-xl font-black italic uppercase tracking-tight ${
              isDarkMode ? "text-white" : "text-slate-900"
            }`}>
              Daily Cap Reached
            </h3>
            <p className="text-[#ff00cc] text-[10px] font-black uppercase tracking-widest mt-1">
              100 Fan Points Earned Today
            </p>
          </div>

          {/* Message Content */}
          <p className={`text-xs leading-relaxed font-medium ${
            isDarkMode ? "text-zinc-400" : "text-slate-600"
          }`}>
            You've hit your daily point limit for rating tracks! You can keep rating and discovering music, but point earnings will pause until midnight.
          </p>

          {/* Action Button */}
          <button
            onClick={onClose}
            className="w-full py-3 px-4 rounded-xl font-black uppercase tracking-wider text-xs bg-[#ff00cc] hover:bg-[#e000b4] text-white transition-all shadow-lg active:scale-95"
          >
            Got It, Keep Rating
          </button>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default DailyCapModal;